<template>
  <div class="registration-page wrapper">
    <!-- <header class="registration-header ph-5">
      <h1 class="text-center">Registration Form</h1>
    </header>
    <div class="registration-form-wrap position-relative">
      <img class="position-absolute registration-bg-1 d-none d-md-block" src="/assets/images/Group 12918.png" alt="" />
      <img class="position-absolute registration-bg-2 d-none d-md-block"
        src="/assets/images/banner/circle-pattern-2.svg " alt="" />
      <div class="container registration-form-container">
        <div class="form">
          <div class="personal-info form-line">
            <label class="registration-form-heading">Personal Information</label>
            <div class="row">
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.name.$error }" placeholder="Name"
                    v-model="model.name"></b-form-input>
                  <div class="invalid-feedback" v-if="!$v.model.name.required">Field is required</div>
                  <span v-if="!$v.model.name.isAlpha && $v.model.name.$error"
                    :class="{ 'invalid-error': $v.model.name.$error }"> Should be an Alphabet </span>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.cnic.$error }" placeholder="B.Form / CNIC (without dashes)"
                    v-model="model.cnic"></b-form-input>

                  <div v-if="!$v.model.cnic.integer && $v.model.cnic.$error"
                    :class="{ 'invalid-error  ': $v.model.cnic.$error }">Should be a number</div>
                  <div v-if="!$v.model.cnic.minLength && $v.model.cnic.$error"
                    :class="{ 'invalid-error': $v.model.cnic.$error }">Minimum 9 digits</div>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" :class="{ 'invalid-input': $v.model.whatsapp.$error }"
                    class="registration-input-field" placeholder="Whatsapp No. (923XXXXXXXXX)"
                    v-model="model.whatsapp"></b-form-input>

                  <div v-if="!$v.model.whatsapp.minLength && $v.model.whatsapp.$error"
                    :class="{ 'invalid-error  ': $v.model.whatsapp.$error }">Minimum 7 digits</div>
                  <div v-if="!$v.model.whatsapp.integer && $v.model.whatsapp.$error"
                    :class="{ 'invalid-error': $v.model.whatsapp.$error }">Should be a number</div>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input type="email" id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.email.$error }" placeholder="Email"
                    v-model="model.email"></b-form-input>

                  <span v-if="!$v.model.email.email && $v.model.email.$error"
                    :class="{ 'invalid-error': $v.model.email.$error }"> Email not correct </span>
                </div>
              </div>
              <div class="col-sm-12 mt-4 radio-btns">
                <div role="group">
                  <span>
                    <input class="form-check-input custom-radio" type="radio" name="pakistan" id="pakistan"
                      value="Pakistan" v-model="model.citizen" :class="{ 'invalid-input': $v.model.citizen.$error }" />
                    <label class="form-check-label" for="pakistan"> Pakistan </label>
                  </span>

                  <span class="ml-5">
                    <input class="form-check-input pl-4 custom-radio" type="radio" name="overseas" id="overseas"
                      value="overseas" v-model="model.citizen" />
                    <label class="form-check-label" for="overseas" @click="model.country = ''"> Overseas </label>
                  </span>
                </div>
              </div>
              <div class="col-sm-12 col-lg-6 mt-4">
                <div class="city-drop-down" role="group" v-if="model.citizen == 'Pakistan'">
                  <v-select :options="cities" placeholder="Select City" label="title"
                    :class="{ 'invalid-input': !model.country && showCityError }" style="border-radius: 5px"
                    @input="onSelect"></v-select>
                </div>
                <div role="group" v-else>
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': !model.country && showCityError }" placeholder="Enter your country"
                    v-model="model.country" @input="onSelect"></b-form-input>
                 
                </div>
              </div>
            </div>
          </div>
          <div class="academic-info form-line">
            <label class="registration-form-heading">Parents / Guardian Information</label>
            <div class="row">
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.fatherName.$error }" placeholder="Name"
                    v-model="model.fatherName"></b-form-input>
                  <span v-if="!$v.model.fatherName.isAlpha && $v.model.fatherName.$error"
                    :class="{ 'invalid-error': $v.model.fatherName.$error }"> Should be an Alphabet </span>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.fatherCnic.$error }" placeholder="CNIC (without dashes)"
                    v-model="model.fatherCnic"></b-form-input>
                  <div v-if="!$v.model.fatherCnic.integer && $v.model.fatherCnic.$error"
                    :class="{ 'invalid-error  ': $v.model.fatherCnic.$error }">Should be a number</div>
                  <div v-if="!$v.model.fatherCnic.minLength && $v.model.fatherCnic.$error"
                    :class="{ 'invalid-error': $v.model.fatherCnic.$error }">Minimum 9 digits</div>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.fatherCell.$error }" placeholder="Cell No. (923XXXXXXXXX)"
                    v-model="model.fatherCell"></b-form-input>
                  <div v-if="!$v.model.fatherCell.integer && $v.model.fatherCell.$error"
                    :class="{ 'invalid-error  ': $v.model.fatherCell.$error }">Should be a number</div>
                  <div v-if="!$v.model.fatherCell.minLength && $v.model.fatherCell.$error"
                    :class="{ 'invalid-error ': $v.model.fatherCell.$error }">Minimum 7 digits</div>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-select v-model="model.fatherIncome" class="registration-select-field"
                    :class="{ 'invalid-input': $v.model.fatherIncome.$error }" size="lg">
                    <b-form-select-option class="mt-3" value="" disabled selected hidden>Select Annual
                      Income</b-form-select-option>
                    <b-form-select-option class="mt-3" value="Less than 15 lacs ">Less than 15 lacs
                    </b-form-select-option>
                    <b-form-select-option class="mt-3" value="15- 25 lacs ">15- 25 lacs </b-form-select-option>
                    <b-form-select-option class="mt-3" value="25-35 lacs ">25-35 lacs </b-form-select-option>
                    <b-form-select-option class="mt-3" value="Above 40 lacs  ">Above 40 lacs </b-form-select-option>
                  </b-form-select>
                </div>
              </div>
            </div>
          </div>
          <div class="academic-info">
            <label class="registration-form-heading">Academic Information</label>
            <div class="row">
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-select v-model="model.lastExam" @change="lastExamChange()" class="registration-select-field"
                    :class="{ 'invalid-input': $v.model.lastExam.$error }" size="lg">
                    <b-form-select-option class="mt-3" value="" disabled selected hidden>Select Last
                      Exam</b-form-select-option>
                    <b-form-select-option class="mt-3" value="11th">11th</b-form-select-option>
                    <b-form-select-option class="mt-3" value="12th">12th</b-form-select-option>
                    <b-form-select-option class="mt-3" value="A Levels">A Levels</b-form-select-option>
                    <b-form-select-option class="mt-3" value="AS Levels">AS Levels</b-form-select-option>
                    <b-form-select-option class="mt-3" value="Other">Other</b-form-select-option>
                  </b-form-select>
                </div>
              </div>
              <div class="col-sm-6 mt-3" v-if="model.lastExam == 'Other'">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.otherLastExam.$error }" placeholder="Your Last Exam"
                    v-model="model.otherLastExam"></b-form-input>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-select v-model="model.passingYear" class="registration-select-field"
                    :class="{ 'invalid-input': $v.model.passingYear.$error }" size="lg">
                    <b-form-select-option class="mandat" value="" disabled selected hidden>Select Passing
                      Year</b-form-select-option>
                    <b-form-select-option class="mandat" value="2024">2024</b-form-select-option>
                    <b-form-select-option class="mandat" value="2023">2023</b-form-select-option>
                    <b-form-select-option class="mandat" value="2022">2022</b-form-select-option>
                    <b-form-select-option class="mandat" value="2021">2021</b-form-select-option>
                  </b-form-select>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field" placeholder="Marks Obtained"
                    v-model="model.marksObtained"
                    :class="{ 'invalid-input': $v.model.marksObtained.$error }"></b-form-input>
                  <div v-if="!$v.model.marksObtained.integer && $v.model.marksObtained.$error"
                    :class="{ 'invalid-error': $v.model.marksObtained.$error }">Should be a number</div>
                  <div v-if="!$v.model.marksObtained.maxValue && $v.model.marksObtained.$error"
                    :class="{ 'invalid-error': $v.model.marksObtained.$error }">Maximum 4 digits</div>
                  <div v-if="!$v.model.marksObtained.between && $v.model.marksObtained.$error"
                    :class="{ 'invalid-error': $v.model.marksObtained.$error }">Obtained Marks should be less than total
                    marks</div>
                </div>
              </div>
              <div class="col-sm-6 mt-3">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field" placeholder="Total Marks"
                    v-model="model.totalMarks" :class="{ 'invalid-input': $v.model.totalMarks.$error }"></b-form-input>
                  <div v-if="!$v.model.totalMarks.integer && $v.model.totalMarks.$error"
                    :class="{ 'invalid-error': $v.model.totalMarks.$error }">Should be a number</div>
                  <div v-if="!$v.model.totalMarks.maxValue && $v.model.totalMarks.$error"
                    :class="{ 'invalid-error': $v.model.totalMarks.$error }">Maximum 4 digits</div>
                </div>
              </div>

              <div class="col-sm-6 mt-3" v-if="model.lastExam !== 'Other'">
                <div role="group">
                  <b-form-select v-model="model.board" class="registration-select-field"
                    :class="{ 'invalid-input': $v.model.board.$error }" size="lg">
                    <b-form-select-option class="mandat" value="" disabled selected hidden>Select
                      Board</b-form-select-option>
                    <b-form-select-option v-if="model.lastExam == '11th' || model.lastExam == '12th'" class="mt-3"
                      value="Federal Board">Federal Board </b-form-select-option>
                    <b-form-select-option class="mt-3" v-if="model.lastExam == '11th' || model.lastExam == '12th'"
                      value="Punjab Board">Punjab Board</b-form-select-option>
                    <b-form-select-option class="mt-3" v-if="model.lastExam == '11th' || model.lastExam == '12th'"
                      value="KPK Board ">KPK Board </b-form-select-option>
                    <b-form-select-option class="mt-3" v-if="model.lastExam == '11th' || model.lastExam == '12th'"
                      value="Sindh Board">Sindh Board</b-form-select-option>
                    <b-form-select-option class="mt-3" v-if="model.lastExam == '11th' || model.lastExam == '12th'"
                      value="Baluchistan Board">Baluchistan Board</b-form-select-option>
                    <b-form-select-option class="mt-3" v-if="model.lastExam == '11th' || model.lastExam == '12th'"
                      value="AJK Board">AJK Board</b-form-select-option>
                    <b-form-select-option class="mt-3" v-if="model.lastExam == '11th' || model.lastExam == '12th'"
                      value="Agha Khan Board">Agha Khan Board</b-form-select-option>
                    <b-form-select-option class="mt-3"
                      v-if="model.lastExam == 'A Levels' || model.lastExam == 'AS Levels'"
                      value="Cambridge International Examinations">Cambridge International Examinations
                    </b-form-select-option>
                    <b-form-select-option class="mt-3"
                      v-if="model.lastExam == 'A Levels' || model.lastExam == 'AS Levels'"
                      value="Pearson Edexcel">Pearson Edexcel </b-form-select-option>
                    <b-form-select-option class="mt-3"
                      v-if="model.lastExam == 'A Levels' || model.lastExam == 'AS Levels' || model.lastExam == 'Other'"
                      value="Other">Other </b-form-select-option>
                  </b-form-select>
                </div>
              </div>
              <div class="col-sm-6 mt-3" v-if="model.lastExam == 'Other' || model.board == 'Other'">
                <div role="group">
                  <b-form-input id="input-formatter" class="registration-input-field"
                    :class="{ 'invalid-input': $v.model.otherBoard.$error }" placeholder="Your Board"
                    v-model="model.otherBoard"></b-form-input>
                </div>
              </div>
              <div v-else></div>
            </div>
          </div>

          <div class="submit-section">
            <button class="registration-submit" @click="makeRegistration" :disabled="submitStatus">Submit <span
                class="spinner-border" v-if="recaptchaLoader"></span></button>
            <div class="recaptcha-message">
              This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a>
              and
              <a href="https://policies.google.com/terms">Terms of Service</a>
              apply.
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-alert class="message-box-app d-flex align-items-center mt-0 mt-md-2" :show="dismissCountDown" dismissible
      variant="danger" @dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged">
      <i class="fas fa-times-circle"></i>
      <div class="alert-cntr">
        <span class="mb0"> ERROR </span>
        <div v-html="this.Message"></div>
      </div>
    </b-alert> -->

    <section id="enrollments" class="enrollment first-section-space">
      <div class="en-bg">
        <div class="container">
          <div class="">
            <div class="headings">
              <h2>Enrollment Process</h2>
            </div>
            <div class="enroll-wrap">
              <div class="enroll">
                <div class="col-lg-4 register">
                  <div class="register-bg process-boxes">
                    <img src="/assets/images/os-images/register.png" alt="" width="56" height="56" />
                  </div>
                  <h4>Registration</h4>
                  <p>Online registration through the KIPS Online School website.</p>
                </div>

                <div class="col-lg-4 assessment">
                  <div class="register-bg process-boxes">
                    <img src="/assets/images/os-images/assesment-en.png" alt="" width="56" height="56" />
                  </div>
                  <h4>Assessment</h4>
                  <p>An initial assessment to understand the student’s current level and learning needs. </p>
                </div>
                <div class="col-lg-4 orientation">
                  <div class="register-bg process-boxes">
                    <img src="/assets/images/os-images/orient-en.png" alt="" width="56" height="56" />
                  </div>
                  <h4>Orientation</h4>
                  <p>A comprehensive orientation session to familiarize students with the online platform and learning
                    resources. </p>
                </div>
              </div>
            </div>
            <div class="enroll-btn">
              <button class="purple-btn" @click="scrollToEnroll">Enroll</button>
              <!-- <button class="purple-btn" @click="openBookDemoPopup()">Enroll</button> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="admission-schedules" class="admission-schedule section-space">
      <div class="container">
        <div class="row">
          <div class="text-div col-md-5">
            <div class="headings">
              <h2>Admission <span class="schedule-text">Schedule</span></h2>
            </div>
            <h4>Primary School (Grade 3–5)
            </h4>
            <ul>
              <li>Orientation & Session Launch: 5th March 2026</li>
            </ul>
            <h4>Lower Secondary (Grade 6-8)
            </h4>
            <ul>
              <li>Orientation & Session Launch: 5th March 2026</li>
            </ul>
            <h4>Secondary School (Grade 9-10)
            </h4>
            <ul>
              <li>Grade 9 Orientation & Session Launch: 1st January 2026</li>
              <li>Grade 10 Orientation & Session Launch: 1st May 2026</li>
              <!-- <li>Session Launch : June 16,2025</li> -->
            </ul>
            <!-- <h4>Higher Secondary School
            </h4>
            <ul>
              <li>Coming Soon</li>
            </ul> -->
            <div class="enroll-btn">
              <button class="purple-btn" @click="scrollToEnroll">Enroll</button>
              <!-- <button class="purple-btn" @click="openBookDemoPopup()">Enroll</button> -->
            </div>
            <!-- <a class="purple-btn" href="#">Schedule Now</a> -->
          </div>
          <div class="col-md-7">
            <img src="/assets/images/os-images/admission-img.png" alt="" width="810" height="780" />
          </div>
        </div>
      </div>
    </section>

    <section id="faq" class="faqs section-space">
      <div class="container">
        <div class="row">
          <div class="text-div col-md-5">
            <div class="headings">
              <h2>Frequently <span class="asked-text">Asked</span> Questions</h2>
            </div>
            <div class="faqs-img">
              <img src="/assets/images/os-images/faqs-image.png" alt="" width="631" height="552" />
            </div>
          </div>
          <div class="col-md-7 kos-accord">
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-1 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">01</h3>
                      <h4 class="acc-head">How can I apply for admission?</h4>
                    </div>
                  </b-card-header>
                </b-button>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>You can apply by visiting the official KIPS Online School website and filling out the
                        registration form in the admissions section.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-2 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">02</h3>
                      <h4 class="acc-head">What are the eligibility criteria for admission?</h4>
                    </div>
                  </b-card-header>
                </b-button>

                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>Students from Grade Playgroup to 12/O-level are eligible. Admission is based on basic
                        registration, profile completion, and an initial assessment.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-3 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">03</h3>
                      <h4 class="acc-head">What documents are required for admission?</h4>
                    </div>
                  </b-card-header>
                </b-button>

                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>Documents include the student’s B-form, recent photograph, academic record, and parent/guardian
                        CNIC, along with contact and address details.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-4 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">04</h3>
                      <h4 class="acc-head">Is there an application fee?</h4>
                    </div>
                  </b-card-header>
                </b-button>
                <b-collapse id="accordion-4" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>No, registration is free. Fee payment begins after registration and is required to confirm
                        admission.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">05</h3>
                      <h4 class="acc-head">How are classes conducted?</h4>
                    </div>
                  </b-card-header>
                </b-button>
                <b-collapse id="accordion-5" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>Classes are conducted online through the KIPS LMS, using recorded video lectures, live
                        sessions, and interactive assignments.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-6 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">06</h3>
                      <h4 class="acc-head">Are there extracurricular activities available?</h4>
                    </div>
                  </b-card-header>
                </b-button>
                <b-collapse id="accordion-6" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>Yes, students can participate in various online co-curricular and enrichment activities
                        throughout the academic year.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-button block v-b-toggle.accordion-7 variant="info">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <div class="acc-head-div">
                      <h3 class="acc-index">07</h3>
                      <h4 class="acc-head">Can students access learning materials after live sessions?</h4>
                    </div>
                  </b-card-header>
                </b-button>
                <b-collapse id="accordion-7" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <p>Yes, all recorded lectures, notes, and resources are available on the LMS for flexible, anytime
                        learning.</p>
                    </b-card-text>
                    <b-card-text>{{ text }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="admission-policies" class="adm-policies section-space">
      <div class="container">
        <div class="row">
          <div class="headings col-12">
            <h2>Admission <span class="policy-text">Policies</span></h2>
          </div>
          <div class="policy-cards">
            <div class="policy-item">
              <div class="policy-icon">
                <img src="/assets/images/os-images/adm-pol.png" alt="" width="50" height="54" />
              </div>
              <div class="policy-card-heading">
                <h4>Admission Policy</h4>
              </div>
              <p>Lorem ipsum dolor sit amet consectetur. Volutpat volutpat tempus erat maecenas congue nam in. Orci euismod non turpis sapien tellus ipsum. Orci lobortis lacinia dui lacinia eget. Eget urna odio lectus.</p>
            </div>

            <div class="policy-item">
              <div class="policy-icon">
                <img src="/assets/images/os-images/fee-pol.png" alt="" width="50" height="54" />
              </div>
              <div class="policy-card-heading space-fee-policy">
                <h4>Fee Policy</h4>
              </div>
              <p>Lorem ipsum dolor sit amet consectetur. Volutpat volutpat tempus erat maecenas congue nam in. Orci euismod non turpis sapien tellus ipsum. Orci lobortis lacinia dui lacinia eget. Eget urna odio lectus.</p>
            </div>

            <div class="policy-item">
              <div class="policy-icon">
                <img src="/assets/images/os-images/leave-pol.png" alt="" width="50" height="54" />
              </div>
              <div class="policy-card-heading space-fee-policy">
                <h4>Leave Policy</h4>
              </div>
              <p>Lorem ipsum dolor sit amet consectetur. Volutpat volutpat tempus erat maecenas congue nam in. Orci euismod non turpis sapien tellus ipsum. Orci lobortis lacinia dui lacinia eget. Eget urna odio lectus.</p>
            </div>

            <div class="policy-item">
              <div class="policy-icon">
                <img src="/assets/images/os-images/att-pol.png" alt="" width="50" height="54" />
              </div>
              <div class="policy-card-heading">
                <h4>Attendance Policy</h4>
              </div>
              <p>Lorem ipsum dolor sit amet consectetur. Volutpat volutpat tempus erat maecenas congue nam in. Orci euismod non turpis sapien tellus ipsum. Orci lobortis lacinia dui lacinia eget. Eget urna odio lectus.</p>
            </div>

            <div class="policy-item">
              <div class="policy-icon">
                <img src="/assets/images/os-images/left-pol.png" alt="" width="50" height="54" />
              </div>
              <div class="policy-card-heading">
                <h4>Left/Freeze Policy</h4>
              </div>
              <p>Lorem ipsum dolor sit amet consectetur. Volutpat volutpat tempus erat maecenas congue nam in. Orci euismod non turpis sapien tellus ipsum. Orci lobortis lacinia dui lacinia eget. Eget urna odio lectus.</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section id="enroll" class="school-grades reg-grade-section-space">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="grade-img-div">
              <img src="/assets/images/os-images/school-grade-img2.png" alt="" width="772" height="648" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="grade-text-div">
              <div class="headings">
                <h2>KIPS Online School <span class="grade-text">Grades</span></h2>
              </div>
              <div class="education-lvl" v-if="categoriesData">
                <div class="category" v-for="(item, index) in categoriesData" :key="index">
                  <div @click="goToCategoryDetail(item)" :class="item.isLinkAble ? 'pointer' : 'not-available'">
                    <span>{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { programCategories as programCategoriesStoreKeys } from "../store/keys";
import cryptojs from "../plugins/crypto";

export default {
  metaInfo: {
    title: "Registration | KIPS ONLINE SCHOOL",

    titleTemplate: "",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  data() {
    return {
      categoriesData: null,
    };
  },
  mounted() {
    if (!this.categoriesFromJson.length) {
      this.getCategoriesList();
    } else {
      this.categoriesData = this.categoriesFromJson;
    }
    this.$nextTick(() => {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        window.scrollTo(0, 0);
      }
    });
  },
  computed: {
    ...mapGetters(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.getters),
  },
  methods: {
    ...mapActions(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.actions),
    async getCategoriesList() {
      const baseUrl = process.env.VUE_APP_URL;
      try {
        const response = await axios.get(`${baseUrl}/assets/categories/index.json`);
        this.categoriesData = response.data.categories;
        this.get_categoriesFromJson({
          data: {
            categories: response.data,
          },
        });
      } catch (error) { }
    },
    goToCategoryDetail(item) {
      this.$router.push({
        path: `${item.link}/${cryptojs.UTF.encrypt(item.programCategoryId)}/${this.getRouteName(item.routeName)}`,
      });
    },
    openBookDemoPopup() {
      Calendly.initPopupWidget({
        url: "https://calendly.com/kipsvirtual/book-a-demo",
      });
      return false;
    },
    scrollToEnroll() {
      const enrollSection = document.querySelector('#enroll');
      if (enrollSection) {
        enrollSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
